;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'product.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'PRODUITS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('productList')
        }],
        categories: ['CategoryManager', 'SessionService', function (CategoryManager, SessionService) {
          return CategoryManager.get(
            CategoryManager
            .query()
            .select(SessionService.getCompany(), 'company')
          ).then(function (data) {
            return _.map(data.data, 'label')
          })
        }],
        linkedSearch: [ '$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch
        } ]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/list/templates/product-list.template.html',
          controller: 'ProductListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product/list/templates/product-list-toolbar.template.html',
          controller: function () {},
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Produits'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular, window._)
